import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";
import { Observable } from "rxjs";
import { Divisa } from "src/app/models/Divisa";
import { DashboardService } from "src/app/services/dashboard.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import Swal from "sweetalert2";

@Component({
	selector: "app-divisas-widget",
	templateUrl: "./divisas-widget.component.html",
	styleUrls: ["./divisas-widget.component.scss"],
})
export class DivisasWidgetComponent implements OnInit {
	public listDivisas: Divisa[] = [];
	public stringDate: string = moment().add(-1, "days").format("L");
	private todayDateString: string;
	private sameDate: boolean;
	@Input() public hideEuro: boolean = false;
	private syncList: boolean = false;
	loadingDivisasValues$: Observable<boolean>;
	constructor(private dashBoardService: DashboardService, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {
		this.loadingDivisasValues$ = this.dashBoardService.isLoadingDailyDivisas;
		this.todayDateString = moment().format("L");
	}

	ngOnInit(): void {
		this.getDivisasList();
	}

	getDivisasList() {
		this.dashBoardService.getDailyDivisas().subscribe(
			(result) => {
				if (result.data && result.data.length > 0) {
					this.listDivisas = result.data.filter((divisa) => divisa.idTipoDivisa != 3);
					this.stringDate = this.todayDateString;
					if (this.stringDate != this.todayDateString && !this.syncList) {
						this.syncDivisas();
					}
					this.ref.detectChanges();
					this.listDivisas = [...this.listDivisas];
				} else {
					this.syncDivisas();
				}
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error al obtener divisas",
					text: "No ha sido posible obtener la lista de divisas. " + error.error ? this.utilities.setErrorMessageFromArray(error.error) : "Error en portal.",
				});
			}
		);
	}

	syncDivisas() {
		this.dashBoardService.syncDivisas().subscribe(
			(result) => {
				this.syncList = result.data;
				this.syncList = true;
				this.getDivisasList();
			},
			(error) => {
			}
		);
	}
}
